$(document).ready(function(){
	stopPropagation();
	resolutionCheck();
	open();
	close();
	closeMDL();
	drop();
	closeDropdown();
	scrollToTop();
	scrollToElement();
	triggerClick();
	toggleTabsActiveClass();
	toggleDisplayByTab();
	objectFitImages();
	// androidDeviceDetection();
	toggle();
	slideToggleFunction();

	formItemSplitHovered();
	formItemFocused();
	showOnCheck();
	showOnRadioCheck();
	formItemActiveDisable();
	refreshStyler();
	formItemInputNumCheck();
	formItemInputNumDotCheck();
	formItemInputNumCommaCheck();
	formItemInputNumDotMinusCheck();
	formItemEmailCheck();
	preventKeyboardTriggeringOnMobile();
	removeErrorFromFormItem();
	styler();
	multiselect();

	svg4everybody();

/* JS for Hagerty only */
	closeHagerty();

/* 	if($('.datepicker').length){
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function(inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow){
				afterShow.apply((inst.input ? inst.input[0] : null));
			}
		};
		$('.datepicker').datepicker({
			changeMonth: true,
			changeYear: true,
			afterShow: function(){
				$('.ui-datepicker-title select').styler();
			},
			minDate: new Date(),
			dateFormat: "mm/dd/y",
			defaultDate: +1
		});
	} */

});

$(window).on('load', function(){

});

$(window).on('scroll', function(){
	var st = $(this).scrollTop();
	if (st > lastScrollTop){
		// downscroll
	}
	else {
		// upscroll
	}
	lastScrollTop = st;

});

$(window).on('resize orientationchange', function(){
	var res = resolutionCheck();
});
